//@flow
import { put, takeLatest, delay, take } from "redux-saga/effects";
import { updateTime } from "./actions";
import moment from "moment";

const UPDATE_INTERVAL_IN_MS = 60000;

function* timeFlow() {
  while (true) {
    yield delay(UPDATE_INTERVAL_IN_MS)

    yield put(updateTime(moment().toDate()));
  }
}



export default timeFlow;
